import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CRMApiAdapter } from '../adapters/CRMApiAdapter';
import { Filters } from '../models/Filters';

interface UseCRMCountByStatusProps {
  search?: string;
  filters?: Filters;
  enabled?: boolean;
}

export const useCRMCountByStatus = ({ search, filters, enabled = true }: UseCRMCountByStatusProps = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new CRMApiAdapter(httpClient);

  const countFilters: Filters = {};
  if (search) countFilters.search = search;
  if (filters?.team_ids) countFilters.team_ids = filters.team_ids;
  if (filters?.shop_ids) countFilters.shop_ids = filters.shop_ids;
  if (filters?.tag_id) countFilters.tag_id = filters.tag_id;
  if (filters?.shipping_country_codes) countFilters.shipping_country_codes = filters.shipping_country_codes;
  if (filters?.payment_method_ids) countFilters.payment_method_ids = filters.payment_method_ids;
  if (filters?.product_ids) countFilters.product_ids = filters.product_ids;
  if (filters?.date_from) countFilters.date_from = filters.date_from;
  if (filters?.date_to) countFilters.date_to = filters.date_to;

  const filterKey = [
    search,
    filters?.team_ids,
    filters?.shop_ids,
    filters?.tag_id,
    filters?.shipping_country_codes,
    filters?.payment_method_ids,
    filters?.product_ids,
    filters?.date_from,
    filters?.date_to,
  ];

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['crm-orders-count-by-status', ...filterKey],
    queryFn: () => adapter.getCRMOrdersCountByStatus(countFilters),
    enabled,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    counts: data?.counts ?? {},
    total: data?.total ?? 0,
    isLoading,
    error,
    refetch,
  };
};
